var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tools01-page-list-active-switch"},[_c('el-switch',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }